<template>
  <section class="mb-20">
    <div class="text-center mb-12">
      <h2 class="text-3xl font-bold text-gray-900 mb-4">四维度恋爱倾向模型</h2>
      <p class="text-lg text-gray-600 max-w-2xl mx-auto">
        从四个核心维度深度分析你的恋爱倾向，精准计算AYP指数
      </p>
    </div>

    <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
      <!-- 成熟偏好 -->
      <div class="card text-center hover:shadow-xl transition-all hover:-translate-y-1 border-2 border-red-100">
        <div class="p-6">
          <div class="text-5xl mb-3">🎓</div>
          <h3 class="font-semibold mb-2 text-lg text-red-600">成熟偏好</h3>
          <p class="text-sm text-gray-600">
            对伴侣成熟度的偏好程度
          </p>
          <div class="mt-3 text-xs text-gray-500">
            <div>高分：喜欢年长伴侣</div>
            <div>低分：年龄不敏感</div>
          </div>
        </div>
      </div>

      <!-- 照顾需求 -->
      <div class="card text-center hover:shadow-xl transition-all hover:-translate-y-1 border-2 border-purple-100">
        <div class="p-6">
          <div class="text-5xl mb-3">💝</div>
          <h3 class="font-semibold mb-2 text-lg text-purple-600">照顾需求</h3>
          <p class="text-sm text-gray-600">
            被照顾的需求强度
          </p>
          <div class="mt-3 text-xs text-gray-500">
            <div>高分：期待被呵护</div>
            <div>低分：独立自主</div>
          </div>
        </div>
      </div>

      <!-- 引导欲望 -->
      <div class="card text-center hover:shadow-xl transition-all hover:-translate-y-1 border-2 border-amber-100">
        <div class="p-6">
          <div class="text-5xl mb-3">🌟</div>
          <h3 class="font-semibold mb-2 text-lg text-amber-600">引导欲望</h3>
          <p class="text-sm text-gray-600">
            引导和照顾对方的欲望
          </p>
          <div class="mt-3 text-xs text-gray-500">
            <div>高分：喜欢引领伴侣</div>
            <div>低分：更愿意跟随</div>
          </div>
        </div>
      </div>

      <!-- 独立倾向 -->
      <div class="card text-center hover:shadow-xl transition-all hover:-translate-y-1 border-2 border-cyan-100">
        <div class="p-6">
          <div class="text-5xl mb-3">🦋</div>
          <h3 class="font-semibold mb-2 text-lg text-cyan-600">独立倾向</h3>
          <p class="text-sm text-gray-600">
            保持独立性的需求
          </p>
          <div class="mt-3 text-xs text-gray-500">
            <div>高分：需要个人空间</div>
            <div>低分：愿意融合</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 计算方法说明 -->
    <div class="mt-12 max-w-3xl mx-auto bg-gradient-to-r from-purple-50 to-psychology-info-10 rounded-2xl p-8 border border-purple-200">
      <div class="flex items-start gap-4">
        <div class="text-4xl">💖</div>
        <div>
          <h3 class="text-xl font-bold text-gray-800 mb-2">科学的AYP计算模型</h3>
          <p class="text-gray-600 leading-relaxed">
            我们使用<strong>加权平均算法</strong>，综合四个维度的得分计算你的AYP指数（0-100分）。
            成熟偏好和照顾需求正向贡献，引导欲望和独立倾向反向贡献，
            精准评估你的<strong>年上年下恋爱倾向</strong>和<strong>依恋类型</strong>。
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'DimensionsSection'
}
</script>

<style scoped>
.card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}
</style>
